"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State;
(function (State) {
    State["STEADY"] = "steady";
    State["PANICMODE"] = "panic-mode";
    State["REBUFFER"] = "rebuffer";
})(State || (State = {}));
exports.default = State;
//# sourceMappingURL=State.js.map